import React from 'react';

export const BoardToolboxBar = ({
  leftInset = '1em',
  children,
  testId = 'board-toolbox-bar',
}) => (
  <div
    data-testid={testId}
    className='fixed bottom-1 z-30 bg-main shadow rounded px-1 py-05 text-contrast select-none flex items-center gap-1 transition-all'
    style={{ left: leftInset }}
  >
    {children}
  </div>
);

export const BoardToolboxOverlay = ({
  rightInset = '1em',
  children,
  testId = 'board-toolbox-overlay',
}) => (
  <div
    data-testid={testId}
    className='fixed top-4 z-30 bg-main shadow rounded px-1 py-05 text-contrast select-none flex items-center gap-1 transition-all'
    style={{ right: rightInset }}
  >
    {children}
  </div>
);

export const BoardToolboxSection = ({ children, className = '' }) => (
  <div
    className={`ml-05 pl-1 border-l border-contrast border-opacity-20 flex items-center gap-05 ${className}`.trim()}
  >
    {children}
  </div>
);

export const BoardToolboxSectionItem = ({
  children,
  className = '',
  side = 'left',
  testId,
}) => {
  const sideClass =
    side === 'right'
      ? 'mr-05 pr-05 border-r border-contrast border-opacity-20'
      : 'ml-05 pl-05 border-l border-contrast border-opacity-20';

  return (
    <div
      data-testid={testId}
      className={`${sideClass} ${className}`.trim()}
    >
      {children}
    </div>
  );
};
